// Assume these are not only popup layers, but also notification layers and maybe something else's layers

export const LAYER = {
    ADVANCED_PLAYER_MESSAGE: 'ADVANCED_PLAYER_MESSAGE',
    ADVANCED_PLAYER_MESSAGE_MODAL: 'ADVANCED_PLAYER_MESSAGE_MODAL',
    BONUS: 'BONUS',
    BONUS_LOW: 'BONUS_LOW',
    BUY_IN_BONUS: 'BUY_IN_BONUS',
    BUY_IN_BONUS_TC: 'BUY_IN_BONUS_TC',
    CARD: 'CARD',
    COMMON: 'COMMON',
    DATA_VERIFICATION: 'DATA_VERIFICATION',
    GAMBLING_SESSION: 'GAMBLING_SESSION',
    GAMES_INFO: 'GAMES_INFO',
    HIGH_PRIORITY: 'HIGH_PRIORITY',
    JUMIO: 'JUMIO',
    LIGHTBOX: 'LIGHTBOX',
    LOGIN: 'LOGIN',
    LOGIN_MESSAGES: 'LOGIN_MESSAGES',
    LOGOUT_MESSAGES: 'LOGOUT_MESSAGES',
    NOTIFICATION: 'NOTIFICATION',
    PROMO_TERMS_AND_CONDITIONS: 'PROMO_TERMS_AND_CONDITIONS',
    QUICK_DEPOSIT: 'QUICK_DEPOSIT',
    SESSION_VALIDATION: 'SESSION_VALIDATION',
    TIME_IS_FLYING: 'TIME_IS_FLYING'
};

// All known visibility layers. The lower the index, the lower the layer visually.
export const LAYERS_ORDER = [
    LAYER.CARD, // quick deposit popup
    LAYER.QUICK_DEPOSIT, // quick deposit popup
    LAYER.GAMES_INFO, // games info popup
    LAYER.ADVANCED_PLAYER_MESSAGE, // 31133 - ActionShowAdvancedDialogInfo
    LAYER.ADVANCED_PLAYER_MESSAGE_MODAL, // 31133 - ActionShowAdvancedDialogInfo {isModal:true}
    LAYER.BUY_IN_BONUS, // buy in bonus popup
    LAYER.BUY_IN_BONUS_TC, // buy in bonus popup: T&C popup
    LAYER.PROMO_TERMS_AND_CONDITIONS, // promotions: T&C popup
    LAYER.COMMON, // all popups by default go here
    LAYER.BONUS_LOW, // notification bonus popups (usually with OK button)
    LAYER.BONUS, // 33005 - popups with confirmation, more important

    LAYER.NOTIFICATION, // "toast" notifications
    LAYER.LIGHTBOX, // popup with iframe in it for redirection calls
    LAYER.TIME_IS_FLYING,
    LAYER.LOGIN, // login popup
    LAYER.GAMBLING_SESSION, // Spanish regulations: GamblingSessionLimits, 60-minutes Interval Message
    LAYER.JUMIO, // JumioVerifyPopup
    LAYER.DATA_VERIFICATION, // dataVerificationStatus popup
    LAYER.SESSION_VALIDATION, // 2FA, FitToPlay, PIN verification
    LAYER.LOGIN_MESSAGES, // waiting messages after login
    LAYER.HIGH_PRIORITY, // legacy 'high priority' popups
    LAYER.LOGOUT_MESSAGES // messages that arrive during logout notification with closeClient=1 have to be shown first
];

export const getLayerId = (layer = 0) =>
    Number.isFinite(layer)
        ? layer
        : LAYERS_ORDER.indexOf(layer) * 1000;

export const layersMeta = {
    [LAYER.CARD]: {
        disableNavigation: true,
        alwaysVisible: true,
        enableOverlay: false
    },
    [LAYER.GAMES_INFO]: {
        disableNavigation: true,
        alwaysVisible: true
    },
    [LAYER.SESSION_VALIDATION]: {
        disableNavigation: true,
        alwaysVisible: true
    },
    [LAYER.ADVANCED_PLAYER_MESSAGE_MODAL]: {
        hideBelow: true
    },
    [LAYER.LOGOUT_MESSAGES]: {
        hideBelow: true,
        disableNavigation: true
    },
    [LAYER.HIGH_PRIORITY]: {
        hideBelow: true,
        disableNavigation: true
    },
    [LAYER.QUICK_DEPOSIT]: {
        alwaysVisible: true
    },
    [LAYER.BUY_IN_BONUS]: {
        alwaysVisible: true
    },
    [LAYER.BUY_IN_BONUS_TC]: {
        alwaysVisible: true
    },
    [LAYER.PROMO_TERMS_AND_CONDITIONS]: {
        alwaysVisible: true
    }
};
